import { type Models as M, Errors as E } from "@lux-ai/api-interface"
import type { LuxAIController } from "../comps/LuxAIController.svelte"
import { Toast } from "toaster"

export async function cancelGeneration(
	generationId: M.ThemeGeneration["id"],
	controller: LuxAIController,
) {
	try {
		await controller.cancelGeneration(generationId)
		Toast.success("Generation cancelled!")
	} catch (e) {
		console.error("Failed to cancel generation", e)

		if (e instanceof E.LuxAiRequestError) Toast.error(e.message)
		else Toast.error("Failed to cancel the generation... Please refresh and try again.")
	}
}
